export async function compressImageFile(file, maxDimension = 750, quality = 0.5) {
  // Only process image files
  if (!file || !file.type || !file.type.startsWith("image/")) {
    return file;
  }

  try {
    // Read file as Data URL
    const dataUrl = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (err) => reject(err);
      reader.readAsDataURL(file);
    });

    // Load image
    const image = await new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = (err) => reject(err);
      img.src = dataUrl;
    });

    const origWidth = image.naturalWidth || image.width;
    const origHeight = image.naturalHeight || image.height;

    if (!origWidth || !origHeight) {
      // If we can't read dimensions, return original
      return file;
    }

    const maxSide = Math.max(origWidth, origHeight);

    // If image is already within maxDimension, keep original to avoid unnecessary recompression
    if (maxSide <= maxDimension) {
      return file;
    }

    const scale = maxDimension / maxSide;
    const targetWidth = Math.round(origWidth * scale);
    const targetHeight = Math.round(origHeight * scale);

    // Draw to canvas at reduced size
    const canvas = document.createElement("canvas");
    canvas.width = targetWidth;
    canvas.height = targetHeight;
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      return file;
    }

    ctx.drawImage(image, 0, 0, targetWidth, targetHeight);

    // Convert canvas back to Blob (JPEG)
    const blob = await new Promise((resolve, reject) => {
      canvas.toBlob(
        (b) => {
          if (b) resolve(b);
          else reject(new Error("Canvas toBlob failed"));
        },
        "image/jpeg",
        quality
      );
    });

    // Preserve base name, change extension to .jpg
    const originalName = typeof file.name === "string" ? file.name : "image";
    const baseName = originalName.replace(/\.[^.]+$/, "");
    const newFileName = `${baseName}.jpg`;

    const compressedFile = new File([blob], newFileName, { type: "image/jpeg" });
    return compressedFile;
  } catch (err) {
    console.error("Error compressing image file, falling back to original:", err);
    // On any error, just return the original file so UX isn't broken
    return file;
  }
}


